import type { ResponseStatus } from '$src/types/forms';
import { RecaptchaService } from '$src/js/modules/recaptcha/RecaptchaService';

const handleNewsletterSubmission = async (form: HTMLFormElement): Promise<void> => {
  form.classList.add('loading-box', 'loading-box--yellow');

  const recaptcha = new RecaptchaService();
  recaptcha.loadRecaptcha();

  const token = await recaptcha.verify();
  const formData = new FormData(form);
  formData.append('g-recaptcha-response', token);

  const response = await fetch(form.action, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': window.csrfTokenValue,
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to submit newsletter');
  }

  const responseData = (await response.json()) as {
    status: ResponseStatus;
  };

  if (responseData.status !== 'success') {
    throw new Error('Failed to submit newsletter');
  }

  form.classList.remove('loading-box', 'loading-box--yellow');
  form.innerText = 'Bedankt voor je inschrijving!';
};

export const initNewsletterSubmission = () => {
  const form = document.querySelector('form[data-validate-form="newsletter"]');

  if (!form) {
    return;
  }

  document.addEventListener('bouncerFormValid', (event) => {
    const form = event.target as HTMLFormElement;

    if (!(form instanceof HTMLFormElement) || form.dataset.validateForm !== 'newsletter') {
      return;
    }

    event.preventDefault();

    handleNewsletterSubmission(form).catch((error: unknown) => {
      console.error('Newsletter submission failed:', error);
    });
  });
};
